'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { useSwanContext } from '../../contexts/swan-provider/swan-provider.context.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r.push.apply(r, n);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
let c = {
    skin: e$1.oneOf([
        'standard',
        'cta',
        'cta-left',
        'unstyled'
    ]),
    width: e$1.oneOf([
        'standard',
        'full-width'
    ]),
    covering: e$1.bool,
    withIcon: e$1.bool,
    withIconSeparated: deprecatedProp(e$1.bool, '`withIconSeparated` behaves the same as `withIcon`, use `withIcon` instead.'),
    to: e$1.string
}, i = new Set(Object.keys(c));
i.delete('to');
let s = Array.from(i);
const Link = createComponent({
    displayName: 'Link',
    root: 'a',
    propTypes: c,
    propKeysToRemove: s,
    propConfig: {
        derivedProps: ()=>useSwanContext(),
        classNames (e) {
            let { skin: t = 'standard', width: r = 'standard', withIcon: n, withIconSeparated: o, covering: a } = e, c = new Set([
                'swan-link'
            ]);
            return 'standard' !== t && c.add(`swan-link-skin-${t}`), 'full-width' === r && c.add("swan-link-full-width"), (n || o) && c.add('swan-link-with-icon'), o && c.add('swan-link-with-icon-separated'), a && c.add('swan-link-covering'), c;
        },
        processProps: (e, t)=>t.globalLinkComponent ? _object_spread_props(_object_spread({}, e), {
                as: e.as || e.component || t.globalLinkComponent
            }) : e.href || e.as || e.component || e.render ? e : _object_spread({
                href: e.to || void 0
            }, e),
        wrapChildren: ({ skin: e$1 }, r, n)=>'cta' === e$1 ? e.createElement(e.Fragment, null, n, e.createElement(Icon, {
                iconType: "arrowRight"
            })) : 'cta-left' === e$1 ? e.createElement(e.Fragment, null, e.createElement(Icon, {
                iconType: "arrowLeft"
            }), n) : n
    }
});

export { Link };
